export default "__VITE_ASSET__e45857e3__"